export const getFileName = (name: string) => {
  if (!name.includes('.')) {
    return name
  }

  return name.substring(0, name.lastIndexOf('.'))
}
